import { render, staticRenderFns } from "./studyCourse.vue?vue&type=template&id=07b6e774&scoped=true&"
import script from "./studyCourse.vue?vue&type=script&lang=js&"
export * from "./studyCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6e774",
  null
  
)

export default component.exports